import { cancel, get, index, post, put, checkNumber } from "src/api/pod";

import PodForm from "src/modules/purchase-order/components/forms/PodForm.vue";
import { findIndex } from "src/assets/scripts/utilities/helpers";

const getInitialState = () => {
  return {
    pods: [],
    pod: {},
  };
};

export const usePodStore = defineStore("pod", () => {
  const formState = ref({
    edit: false,
    open: false,
    props: null,
    view: false,
  });

  const togglePodForm = (state = {}) => {
    formState.value = {
      edit: false,
      open: !formState.value.open,
      view: false,
      ...state,
    };

    const { toggleRightDrawer, toggleNestedRightDrawer } = useAppStore();

    if (Object.hasOwn(unref(formState), "level")) {
      toggleNestedRightDrawer({
        component: PodForm,
        level: unref(formState).level,
        open: unref(formState).open,
        props: unref(formState).props,
      });
    } else {
      toggleRightDrawer(unref(formState).open, PodForm, unref(formState).props);
    }
  };

  let state = reactive(getInitialState());

  const setPod = (updatedPod) => {
    const updatedPodIndex = findIndex(state.pods, updatedPod, "_id");

    const listedPod = state.pods[updatedPodIndex];

    state.pod = { ...listedPod, ...updatedPod };

    state.pods[updatedPodIndex] = state.pod;
  };

  const cancelPod = async (params) => {
    try {
      const response = await cancel(params);

      setPod(response.data?.data);

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const getPod = async ({ id, source = "kam" }) => {
    try {
      state.pod = state.pods.find((pod) => pod._id === id);

      const response = await get({ id, source });

      if (source === "sales") {
        state.pod = response?.data?.data;
      } else {
        setPod(response?.data?.data);
      }

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const filters = ref({
    po_id: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const getPods = async (options = {}) => {
    try {
      options = unref(options);

      if (options?.filters) {
        filters.value = options?.filters;

        delete options.filters;
      }

      const response = await index({
        params: params.value,
        ...options,
      });

      state.pods = response.data?.data?.data;

      pagination.value.rowsNumber = response.data?.data?.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postPod = async (pod) => {
    try {
      const response = await post(pod);

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const putPod = async (pod) => {
    try {
      const response = await put(pod);

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const addFile = (file) => {
    const podIndex = findIndex(state.pods, { _id: file.pod_id }, "_id");

    if (podIndex !== -1) {
      state.pods[podIndex].files.unshift(file);
    }
  };

  const updateFile = (file) => {
    const podIndex = findIndex(state.pods, { _id: file.pod_id }, "_id");

    const fileIndex = findIndex(
      state.pods[podIndex].files,
      { _id: file._id },
      "_id",
    );

    if (podIndex !== -1 && fileIndex !== -1) {
      if (file.status === "Active") {
        state.pods[podIndex].files[fileIndex] = file;
      } else {
        state.pods[podIndex].files.splice(fileIndex, 1);
      }
    }
  };

  const isDuplicate = async (number) => {
    const response = await checkNumber(number);

    return response;
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    formState,
    togglePodForm,

    filter,
    filters,
    pagination,

    ...toRefs(state),

    cancelPod,
    getPod,
    getPods,
    postPod,
    putPod,
    setPod,
    isDuplicate,

    addFile,
    updateFile,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePodStore, import.meta.hot));
}
